/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from "react";
import cssClasses from "./Profile.module.css";
//MUI
import { makeStyles } from "@mui/styles";
import CustomInput from "../../Subcomponents/CustomInput";
//services
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Redux Store/actions";
import EmptyListIcon from "../../Assets/Images/EmptyDataIcons/WalletisEmpty@3x.svg";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import { Card, CardContent, Divider, Grid, Tooltip, useMediaQuery } from "@mui/material";
import { debounce } from "lodash";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import {
	checkLeadEmailExists,
	checkLeadEmailExistsInCp,
	checkLeadEmailExistsInUsers,
	checkPhoneNumberIsBlackListed,
	getVirtualAccountStatus,
	logIn,
	logOut,
} from "../../Services/Login";
import { errorTost, successTost } from "../../Services/Toast";
import { sendOTPMessage, sendOTPMessageMail } from "../../Services/SmsService";
import CryptoJS from "crypto-js";
import { updateLeadLoginTable, updateLeadPersonTable } from "../../Services/Leads";
import { supabase } from "../../supabaseClient";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import UserIcon from "../../Assets/Images/Common/ProfileUser-01.svg";
import ProfileUserIcon from "../../Assets/Images/Common/ProfileUser.svg";
import MailIcon from "../../Assets/Images/Common/mail12profile.svg";
import ProfileCallIcon from "../../Assets/Images/Common/phone16profile.svg";
import PhoneCallIcon from "../../Assets/Images/Common/phone12profile.svg";
import ProfileMAilIcon from "../../Assets/Images/Common/mail16profile.svg";
import { dismissLoader, presentLoader } from "../../Services/loader";
import InfoIcon from "../../Assets/Images/Common/info-circle.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";

// ? capacitor network for online/offline status
// import { Network } from "@capacitor/network";
const useStyles = makeStyles((theme) => ({
	customTextField: {
		"& input::placeholder": {
			fontSize: "1.6rem !important",
		},
	},
	autoCompleteInput: {
		fontSize: "1.6rem !important",
		fontFamily: "Inter-Medium !important",
		lineHeight: "2.4rem !important",
	},
	stepper: {
		"& .MuiLinearProgress-root": {
			backgroundColor: "rgba(82, 108, 130, 0.1) !important",
			height: "0.8rem !important",
			borderRadius: "5rem !important",
			width: "100% !important",
			"& .MuiLinearProgress-bar": {
				backgroundColor: "#155EEF !important",
			},
		},
	},
}));

const Profile = () => {
	const dispatch = useDispatch();
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	const switchUser = useSelector((state) => state.Auth.isSwitchUser);
	const navigate = useNavigate();
	const [virtualAccStatuses, setVirtualAccStatuses] = useState("");

	const [allUsers, setAllUser] = useState([]);
	const [selectedUser, setSelectedUser] = useState({});
	const [selectedLeadData, setSelectedLeadData] = useState({});
	const [emailLabelText, setEmailLabelText] = useState("");
	const [updateProfile, setUpdateProfile] = useState({
		email: "",
		contactNumber: "",
	});
	const [helperText, setHelperText] = useState({
		email: "",
		isPhoneNumber: "",
		disableEmail: true,
		disableContactNumber: true,
		onChangePhoneNumber: false,
	});

	const [isLoadingEmail, setIsLoadingEmail] = useState(false);
	const verifiedPhoneNumber = useRef(false);
	const verifiedEmail = useRef(false);
	const [otptimerEmail, setOtpTimerEmail] = useState(false);
	const [showEmailOtp, setShowEmailOtp] = useState(false);
	const [emailState, setEmailState] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});
	const [recievedEmailOtp, setRecievedEmailOtp] = useState(null);
	// ------------------------Phone number otp
	const [showOtp, setShowOtp] = useState(false);
	const [isInterNational, setIsInterNational] = useState(false);
	const [resendButton, setResendButton] = useState(false);
	const [otptimer, setOtpTimer] = useState(false);
	const [state, setState] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});
	const [recievedOtp, setRecievedOtp] = useState(null);
	const [personDetails, setPersonDetails] = useState({ email: "", contactNumber: "" });
	const showVirtualAccountCard = useMediaQuery("(max-width:820px)");

	useEffect(() => {
		if (loggedInUser?.personId?.personId) {
			supabase
				.from("Person")
				.select("email, contactNumber")
				.eq("personId", loggedInUser.personId.personId)
				.single()
				.then(({ data }) => {
					if (data) {
					setPersonDetails({ email: data.email, contactNumber: data.contactNumber });
					setUpdateProfile((pre) => ({
						...pre,
						email: data.email,
						contactNumber: "+" + data.contactNumber,
					}));
				}
				});
		}
	}, [loggedInUser?.personId?.personId]);

	useEffect(() => {}, [switchUser]);
	useEffect(() => {
		if (loggedInUser?.virtualAccId) {
			getVirtualAccStatus(loggedInUser?.virtualAccId);
		}
	}, [loggedInUser]);
	useEffect(() => {
		// setProfileData(loggedInUser);
		if (!updateProfile.email) {
			setUpdateProfile((pre) => {
				pre.email = loggedInUser?.personId?.email;
				pre.contactNumber = "+" + loggedInUser?.personId?.contactNumber;
				return { ...pre };
			});
		}
		dispatch(actions.activeMenu("profile"));
		setAllUser(JSON.parse(localStorage.getItem("LeadList")));
		let selectedUser = JSON.parse(localStorage.getItem("selectedLead"));
		let allUsers = JSON.parse(localStorage.getItem("LeadList"));
		let selectedUserfromArray = allUsers.filter(({ personId }) => personId === selectedUser?.personId?.personId);
		setSelectedLeadData(selectedUserfromArray);
		setSelectedUser(selectedUser?.personId?.personId);
		if (loggedInUser?.virtualAccId) {
		}
	}, [loggedInUser]);

	async function getVirtualAccStatus(AccId) {
		presentLoader();
		await getVirtualAccountStatus(AccId)
			.then((resp) => {
				setVirtualAccStatuses(resp?.data?.status);
				dismissLoader();
			})
			.catch((err) => {
				errorTost("Request timed out. Please try again later!");
				console.error("could-not-fetch-details", err);
				dismissLoader();
			});
	}

	//  -----------------------------------------------------------------------------------------------
	// !!Otp
	const checkEmailExists = useRef(
		debounce(async (e) => {
			let emailExists = null;
			// ??First checked in leads
			await checkLeadEmailExists(e)
				.then((emailCheckResp) => {

					if (emailCheckResp.length > 0) {
						emailExists = true;
					} else {
						emailExists = false;
						setHelperText((pre) => {
							pre.email = "";
							return { ...pre };
						});
					}
				})
				.catch((error) => {
					console.error(error);
				});
			// ??Second Check in Users
			if (!emailExists) {
				await checkLeadEmailExistsInUsers(e)
					.then((responseInUser) => {
						if (responseInUser.length > 0) {
							emailExists = true;
						} else {
							emailExists = false;
						}
					})
					.catch((err) => {
						console.error(err.message);
					});
			}
			// ??Third Check in Cp
			if (!emailExists) {
				await checkLeadEmailExistsInCp(e).then((cpRespEmail) => {
					if (cpRespEmail.length > 0) {
						emailExists = true;
					} else {
						emailExists = false;
					}
				});
			}
			if (emailExists) {
				setHelperText((pre) => {
					pre.email = "Email Already exists";
					return { ...pre };
				});
				setEmailLabelText("");
			} else {
				setHelperText((pre) => {
					pre.email = "";
					return { ...pre };
				});
				setEmailLabelText("Send Otp");
			}
		}, 900)
	).current;
	function sendOtpToVerifyEmail() {
		setHelperText((pre) => {
			pre.email = "";
			return { ...pre };
		});
		setShowEmailOtp(true);
		setOtpTimerEmail(true);
		setEmailLabelText("");
		let body = {
			email: updateProfile.email,
		};
		sendOTPMessageMail(body).then((resp) => {
			if (resp.data.success) {
				var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
				var originalText = bytes.toString(CryptoJS.enc.Utf8);
				// console.log("Email Registration OTP", parseInt(originalText));
				setRecievedEmailOtp(parseInt(originalText));
				// 900000 ;15 min
				const myTimeout = setTimeout(smsTimeOutForEmailVerify, 900000);
			} else {
				if (resp?.data?.error?.ErrorMessage) {
					errorTost(resp?.data?.error?.ErrorMessage);
				} else {
					errorTost("Something went wrong");
				}
			}
		});
	}
	function smsTimeOutForEmailVerify() {
		if (verifiedEmail === false) {
			setHelperText((pre) => {
				pre.email = "Otp has expired.Please resend otp";
				return { ...pre };
			});
			setEmailLabelText("Resend Otp");
			setOtpTimerEmail(false);
			// setVerifiedEmail(false);
			verifiedEmail.current = false;
		} else {
			setShowEmailOtp(true);
			setOtpTimerEmail(true);
			setEmailState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			setRecievedEmailOtp(null);
		}
	}
	// !!Email otp
	function optEmailChange(value1, event) {
		event.preventDefault();
		if (event.target.value.length <= 1) {
			setEmailState((pre) => {
				pre[value1] = event.target.value;
				return Object.assign({}, pre);
			});
		}
	}
	const inputfocus = (elmnt) => {
		if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
			// const next = elmnt.target.tabIndex - 2;
			// if (next > -1) {
			//     // elmnt.target.form.elements[next].focus();
			//     if (elmnt.target.nextSibling)
			//         elmnt.target.nextSibling.focus();
			// }
		} else {
			// const next = elmnt.target.tabIndex + 1;
			const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
			if (next < 5) {
				// elmnt.target.form.elements[next].focus();
				if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
			}
		}
	};
	// !!For Email
	function submitEmailOtp() {
		let finalValue = emailState.otp1 + emailState.otp2 + emailState.otp3 + emailState.otp4;
		// console.log(finalValue, "recievedEmailOtp", recievedEmailOtp);
		if (finalValue == recievedEmailOtp) {
			// setVerifiedEmail(true);
			verifiedEmail.current = true;
			setShowEmailOtp(false);
			setOtpTimerEmail(false);
			setEmailLabelText("");
			setEmailState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
		} else {
			setEmailState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			errorTost("OTP doesnt match.Please enter valid otp");
		}
	}
	// -------------------------------------------------------------------------------
	const IsNumberBlackListed = useRef(
		debounce((e) => {
			checkPhoneNumberIsBlackListed(e)
				.then((resp) => {
					verifiedPhoneNumber.current = false;
					// setVerifiedPhoneNumber(false);
					if (resp.length > 0) {
						setHelperText((pre) => {
							pre.isPhoneNumber = "This number is already in use!";
							// pre.isPhoneNumber = "This number has been blacklisted";
							return { ...pre };
						});
					} else {
						setHelperText((pre) => {
							pre.isPhoneNumber = "";
							pre.onChangePhoneNumber = true;
							return { ...pre };
						});
						// setVerifiedPhoneNumber(true);
					}
				})
				.catch((err) => {
					console.error(err);
				});
		}, 800)
	).current;
	function smsApiCall() {
		setResendButton(false);
		setState((pre) => {
			pre.otp1 = "";
			pre.otp2 = "";
			pre.otp3 = "";
			pre.otp4 = "";
			return { ...pre };
		});
		setShowOtp(true);
		let body = {
			number: updateProfile.contactNumber,
			isInterNational: isInterNational,
		};

		sendOTPMessage(body)
			.then((resp) => {
				if (resp.data.success) {
					var decodedOtp = atob(resp.data.otp);
					var bytes = CryptoJS.AES.decrypt(decodedOtp, "hts secret key");
					var originalText = bytes.toString(CryptoJS.enc.Utf8);
					// console.log("Mobile Registration OTP", parseInt(originalText));
					setRecievedOtp(parseInt(originalText));
					// 900000 ;15 min
					const myTimeout = setTimeout(smsTimeOut, 900000);
				} else {
					if (resp?.data?.error?.ErrorMessage) {
						errorTost(resp?.data?.error?.ErrorMessage);
					} else {
						errorTost("Something went wrong");
					}
				}
			})
			.catch((err) => {
				console.error(err);
			});
	}
	function smsTimeOut() {
		if (verifiedPhoneNumber.current === false) {
			setHelperText((pre) => {
				pre.isPhoneNumber = "Otp has expired.Please resend otp";
				return { ...pre };
			});
			verifiedPhoneNumber.current = false;
			setShowOtp(true);
			setResendButton(true);
			setOtpTimer(true);
			// setShowEmailOtp(false);
			setState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			setRecievedOtp(null);
		}
	}
	function optChange(value1, event) {
		event.preventDefault();
		if (event.target.value.length <= 1) {
			setState((pre) => {
				pre[value1] = event.target.value;
				return Object.assign({}, pre);
			});
		}
	}
	function submitOtp() {
		let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
		// console.log(finalValue, "recievedOtp", recievedOtp);
		if (finalValue == recievedOtp) {
			// setVerifiedPhoneNumber(true);
			verifiedPhoneNumber.current = true;
			setShowOtp(false);
			setOtpTimer(false);
			setHelperText((pre) => {
				pre.isPhoneNumber = "";
				return { ...pre };
			});
		} else {
			setState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			errorTost("OTP doesnt match.Please enter valid otp");
		}
	}

	async function switchLoginUser(selectedLead) {
		dispatch(actions.authSwitchUser());
		presentLoader();
		setTimeout(() => {
			logOut().then((logOutResp) => {
				if (logOutResp) {
					logIn(selectedLead.personId.contactNumber, selectedLead.leadDisplayId)
						.then((loginResp) => {
							if (loginResp) {
								setSelectedUser(selectedLead);
								localStorage.setItem("selectedLead", JSON.stringify(selectedLead));
								dispatch(actions.authLogin(selectedLead));
								navigate("/Home");
								dismissLoader();
								dispatch(actions.authSwitchUserFalse());
							} else {
								errorTost("Could not switch user. Try again later!");
								dismissLoader();
							}
						})
						.catch((err) => {
							console.log("switchUserLogIn-logOut-logIn", err);
							errorTost("Could not switch user. Try again later!");
							dismissLoader();
						});
				}
			});
		}, 1000);
		// }
	}
	// -------------------------------------------------------------------
	return (
		<div className={cssClasses.mainWrapper}>
			<div className={cssClasses.section}>
				<div className={cssClasses.leadDetailsWrap}>
					<div className={cssClasses.contentWrapOne}>
						<div className={cssClasses.content}>
							<div className={cssClasses.profileCardHeader}>
								<p className={cssClasses.userDisplayID}>
									{`Your CUID is VJ${loggedInUser?.leadDisplayId.slice(0, -4) + "-" + loggedInUser?.leadDisplayId.slice(-4)}`}
								</p>
							</div>
							<div className={cssClasses.profileDetailsContent}>
								<div className={cssClasses.userName}>
									<div className={cssClasses.profileImgName}>
										<img src={ProfileUserIcon} alt="user" />
										<span className={cssClasses.name}>{loggedInUser?.personId?.name}</span>
									</div>

									<div className={cssClasses.userSatus}>
										<LeadStatusChip
											label={selectedLeadData[0]?.Leads[0]?.LeadStatus[0].status}
											style={{
												color: selectedLeadData[0]?.leadStatusObj?.chipColor,
												backgroundColor: selectedLeadData[0]?.leadStatusObj?.chipBackgroundColor,
												// fontFamily: "Inter-Regular",
												// fontSize: 8,
											}}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										/>
									</div>
								</div>
								<div className={cssClasses.userDetails}>
									<img className={cssClasses.profileImg} src={ProfileMAilIcon} alt="call" />
									<span>{personDetails.email || loggedInUser?.personId?.email}</span>
								</div>
								<div className={cssClasses.userDetails}>
									<img className={cssClasses.profileImg} src={ProfileCallIcon} alt="call" />
									<span>{personDetails.contactNumber || loggedInUser?.personId?.contactNumber}</span>
								</div>

								<div
									style={{
										display: "flex",
										//  alignItems: 'center',
										width: "100%",
										justifyContent: "flex-start",
										gap: "1rem",
										alignItems: "flex-end",
									}}
								>
									<div style={{ width: "80%" }} className={cssClasses.inputWidth}>
										<CustomInput
											value={updateProfile?.email}
											label={"Email"}
											mandatory={true}
											inputType={"label"}
											position={"end"}
											greenTick={verifiedEmail.current === true}
											labelText={emailLabelText}
											disabled={showEmailOtp || verifiedEmail.current === true || helperText.disableEmail}
											clicked={(e) => {
												console.log(e);
												if (e === "Send Otp") {
													sendOtpToVerifyEmail(e);
												} else if (e === "Resend Otp") {
													sendOtpToVerifyEmail(e);
												}
											}}
											handleChange={(newValue) => {
												setEmailLabelText("");
												newValue = newValue.trimStart();
												const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
												if (!newValue.trim()) {
													setEmailLabelText("");
													helperText.email = "Please Enter Email Id";
												} else if (!newValue.match(emailIDCond)) {
													setEmailLabelText("");
													helperText.email = "Please Enter Email in Proper Format";
												} else {
													setIsLoadingEmail(true);
													setEmailLabelText("");
													helperText.email = "verifying...";
													if (newValue !== "") {
														checkEmailExists(newValue);
													} else if (newValue === "") {
														setEmailLabelText("");
													}
												}
												if (newValue.length <= 100) {
													setUpdateProfile((pre) => {
														pre.email = newValue;
														return { ...pre };
													});
												}
											}}
											placeholder="Enter contact person Email"
											helperText={helperText.email}
											// isLoading={isLoadingEmail}
										/>
										{otptimerEmail && (
											<div className={cssClasses.resendOtp}>
												{" "}
												Resend Otp in{" "}
												<CountdownTimer
													startFrom={180}
													onComplete={() => {
														setEmailLabelText("Resend Otp");
														setOtpTimerEmail(false);
													}}
													timeFormatter={(time) => {
														return (
															<span>
																{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}
															</span>
														);
													}}
												/>
											</div>
										)}
										{showEmailOtp && (
											<div className={cssClasses.otpContainer}>
												<input
													className={cssClasses.otpInput}
													name="otp1"
													type="number"
													autoComplete="off"
													value={emailState.otp1}
													// onKeyPress={keyPressed}
													onChange={(e) => optEmailChange("otp1", e)}
													tabIndex="1"
													maxLength="1"
													onKeyUp={(e) => inputfocus(e)}
													id="opt-0"
													inputMode="numeric"
													pattern="[0-9]*"
												/>
												<input
													name="otp2"
													type="number"
													autoComplete="off"
													className={cssClasses.otpInput}
													value={emailState.otp2}
													onChange={(e) => optEmailChange("otp2", e)}
													tabIndex="2"
													maxLength="1"
													onKeyUp={(e) => inputfocus(e)}
													id="opt-1"
													inputMode="numeric"
													pattern="[0-9]*"
												/>
												<input
													name="otp3"
													type="number"
													autoComplete="off"
													className={cssClasses.otpInput}
													value={emailState.otp3}
													onChange={(e) => optEmailChange("otp3", e)}
													tabIndex="3"
													maxLength="1"
													onKeyUp={(e) => inputfocus(e)}
													id="opt-2"
													inputMode="numeric"
													pattern="[0-9]*"
												/>
												<input
													name="otp4"
													type="number"
													autoComplete="off"
													className={cssClasses.otpInput}
													value={emailState.otp4}
													onChange={(e) => optEmailChange("otp4", e)}
													tabIndex="4"
													maxLength="1"
													onKeyUp={(e) => inputfocus(e)}
													id="opt-3"
													inputMode="numeric"
													pattern="[0-9]*"
												/>

												<div>
													<Button
														tabIndex={5}
														style={{
															color: "#ffffff",
															backgroundColor: "#155EEF",
															fontSize: "1.4rem",
															lineHeight: "2rem",
														}}
														btnName={"Submit OTP"}
														clicked={submitEmailOtp}
													/>
												</div>
											</div>
										)}
									</div>
									{helperText.disableEmail && (
										<div
											style={{
												display: "flex",
												cursor: "pointer",
												marginBottom: "2rem",
											}}
											onClick={() => {
												setHelperText((pre) => {
													pre.disableEmail = false;
													return { ...pre };
												});
											}}
										>
											<span className={cssClasses.leadLastUpdate} style={{ marginRight: "1rem" }}>
												Edit
											</span>
											<Tooltip title="Edit" disableInteractive>
												<EditIcon
													id="isEdit"
													style={{
														fontSize: "2rem",
														cursor: "pointer",
														color: "rgb(21, 112, 239)",
													}}
													onClick={() => {
														// onChangeEdit(element.value ? element.value : element);
													}}
												/>
											</Tooltip>
										</div>
									)}
									{verifiedEmail.current && (
										<div>
											<Button
												tabIndex={5}
												style={{
													color: "#ffffff",
													backgroundColor: "#155EEF",
													fontSize: "1.4rem",
													lineHeight: "2rem",
												}}
												btnName={"Update"}
												clicked={() => {
													// Update Query Remaining
													let obj = {
														email: updateProfile.email,
													};
													updateLeadPersonTable(loggedInUser?.personId?.personId, obj)
														.then((response) => {
															successTost("Email updated successfully");
															setPersonDetails((pre) => ({ ...pre, email: updateProfile.email }));
															setUpdateProfile((pre) => ({ ...pre, email: updateProfile.email }));
															obj = {
																...loggedInUser.personId,
																email: updateProfile.email,
															};
															dispatch(
																actions.authLogin({
																	...loggedInUser,
																	personId: obj,
																})
															);
														})
														.catch((err) => {
															console.log(err);
														});
													setHelperText((pre) => {
														pre.disableEmail = true;
														return { ...pre };
													});
													// setVerifiedEmail(false);
													verifiedEmail.current = false;
													setOtpTimerEmail(false);
													setShowEmailOtp(false);
												}}
											/>
										</div>
									)}
								</div>
								{/* Phone Number Block */}
								<div
									style={{
										display: "flex",
										justifyContent: "flex-start",
										gap: "1rem",
										alignItems: "flex-end",
										width: "100%",
									}}
								>
									<div style={{ position: "relative", width: "80%" }} className={cssClasses.inputWidth}>
										<div className={cssClasses.blockLabel}>
											Phone Number <span style={{ color: "red" }}> *</span>
										</div>
										<PhoneInput
											defaultCountry="IN"
											value={updateProfile.contactNumber}
											disabled={showOtp || verifiedPhoneNumber.current || resendButton || helperText.disableContactNumber}
											placeholder="Enter phone number"
											onChange={(phone) => {
												setUpdateProfile((pre) => {
													pre.contactNumber = phone === undefined ? "+91" : phone;
													return { ...pre };
												});
												if (
													"+" + loggedInUser?.personId?.contactNumber.toString() ===
													updateProfile.contactNumber.toString()
												) {
													setHelperText((pre) => {
														pre.onChangePhoneNumber = false;
														return { ...pre };
													});
												} else {
													setHelperText((pre) => {
														pre.onChangePhoneNumber = true;
														return { ...pre };
													});
												}
												if (phone !== undefined) {
													// setVerifiedPhoneNumber(false);
													verifiedPhoneNumber.current = false;
													if (phone.length >= 1) {
														if (isValidPhoneNumber(phone) === false) {
															verifiedPhoneNumber.current = false;
															helperText.isPhoneNumber = `Please Enter valid Phone Number`;
															setShowOtp(false);
														} else {
															helperText.isPhoneNumber = "verifying...";
															if (phone?.substring(0, 3) === "+91") {
																setIsInterNational(false);
															} else {
																setIsInterNational(true);
															}
															IsNumberBlackListed(phone);
														}
													}
												} else {
													helperText.isPhoneNumber = "Please Enter  Phone Number";
													setShowOtp(false);
												}
											}}
										/>
										<p
											style={{
												color: "red",
												fontSize: "1.4rem",
												lineHeight: "1.66",
											}}
										>
											{helperText.isPhoneNumber}
										</p>
										{helperText.isPhoneNumber === "" &&
											verifiedPhoneNumber.current === false &&
											otptimer === false &&
											showOtp === false &&
											updateProfile.contactNumber !== "" &&
											!helperText.disableContactNumber &&
											helperText.onChangePhoneNumber && (
												<div
													className={cssClasses.verifyOtp}
													onClick={() => {
														smsApiCall();
													}}
												>
													Verify Otp
												</div>
											)}

										{verifiedPhoneNumber.current === false && showOtp === true && resendButton === true && (
											<div
												className={cssClasses.verifyOtp}
												onClick={() => {
													setHelperText((pre) => {
														pre.isPhoneNumber = "";
														return { ...pre };
													});
													if (resendButton) {
														smsApiCall();
														// successTost("Otp has been sent");
													} else {
														console.log("Please wait for 3 min");
													}
												}}
											>
												Resend Otp
											</div>
										)}
										{verifiedPhoneNumber.current === false && showOtp === true && resendButton === false && (
											<div className={cssClasses.resendOtp}>
												{" "}
												Resend Otp in {/* <Countdown date={startDate.current+ 180000} renderer={renderer} /> */}
												<CountdownTimer
													startFrom={180}
													onComplete={() => {
														setResendButton(true);
													}}
													timeFormatter={(time) => {
														return (
															<span>
																{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}
															</span>
														);
													}}
												/>
											</div>
										)}
										{helperText.isPhoneNumber === "" && verifiedPhoneNumber.current && otptimer === false && (
											<div className={cssClasses.verifyOtp}>
												<CheckCircleSharpIcon style={{ fontSize: "2.5rem", marginRight: "1rem" }} color={"success"} />
											</div>
										)}
										{showOtp && (
											<div className={cssClasses.otpContainer}>
												<input
													className={cssClasses.otpInput}
													name="otp1"
													type="number"
													autoComplete="off"
													value={state.otp1}
													// onKeyPress={keyPressed}
													onChange={(e) => optChange("otp1", e)}
													tabIndex="1"
													maxLength="1"
													onKeyUp={(e) => inputfocus(e)}
													id="opt-0"
													inputMode="numeric"
													pattern="[0-9]*"
												/>
												<input
													name="otp2"
													type="number"
													autoComplete="off"
													className={cssClasses.otpInput}
													value={state.otp2}
													onChange={(e) => optChange("otp2", e)}
													tabIndex="2"
													maxLength="1"
													onKeyUp={(e) => inputfocus(e)}
													id="opt-1"
													inputMode="numeric"
													pattern="[0-9]*"
												/>
												<input
													name="otp3"
													type="number"
													autoComplete="off"
													className={cssClasses.otpInput}
													value={state.otp3}
													onChange={(e) => optChange("otp3", e)}
													tabIndex="3"
													maxLength="1"
													onKeyUp={(e) => inputfocus(e)}
													id="opt-2"
													inputMode="numeric"
													pattern="[0-9]*"
												/>
												<input
													name="otp4"
													type="number"
													autoComplete="off"
													className={cssClasses.otpInput}
													value={state.otp4}
													onChange={(e) => optChange("otp4", e)}
													tabIndex="4"
													maxLength="1"
													onKeyUp={(e) => inputfocus(e)}
													id="opt-3"
													inputMode="numeric"
													pattern="[0-9]*"
												/>

												<div>
													<Button
														tabIndex={5}
														style={{
															color: "#ffffff",
															backgroundColor: "#155EEF",
															fontSize: "1.4rem",
															lineHeight: "2rem",
														}}
														btnName={"Submit OTP"}
														clicked={submitOtp}
													/>
												</div>
											</div>
										)}
									</div>
									<div>
										{helperText.disableContactNumber && (
											<div
												style={{
													display: "flex",
													cursor: "pointer",
													marginBottom: "2rem",
												}}
												onClick={() => {
													setHelperText((pre) => {
														pre.disableContactNumber = false;
														return { ...pre };
													});
												}}
											>
												<span className={cssClasses.leadLastUpdate} style={{ marginRight: "1rem" }}>
													Edit
												</span>
												<Tooltip title="Edit" disableInteractive>
													<EditIcon
														id="isEdit"
														style={{
															fontSize: "2rem",
															cursor: "pointer",
															color: "rgb(21, 112, 239)",
														}}
													/>
												</Tooltip>
											</div>
										)}
										{verifiedPhoneNumber.current && (
											<div>
												<Button
													tabIndex={5}
													style={{
														color: "#ffffff",
														backgroundColor: "#155EEF",
														fontSize: "1.4rem",
														lineHeight: "2rem",
													}}
													btnName={"Update"}
													clicked={() => {
														// Update Query Remaining
														let obj = {
															contactNumber: updateProfile.contactNumber,
														};
														let obj2 = { number: updateProfile.contactNumber };
														Promise.all([
															updateLeadPersonTable(loggedInUser?.personId?.personId, obj),
															updateLeadLoginTable(loggedInUser?.leadDisplayId, obj2),
														])
															.then((response) => {
																successTost("Phone Number updated successfully");
																const newNumber = updateProfile.contactNumber.startsWith("+") ? updateProfile.contactNumber.slice(1) : updateProfile.contactNumber;
																setPersonDetails((pre) => ({ ...pre, contactNumber: newNumber }));
																setUpdateProfile((pre) => ({ ...pre, contactNumber: updateProfile.contactNumber }));
																obj = {
																	...loggedInUser.personId,
																	contactNumber: response[0].contactNumber,
																};
																dispatch(
																	actions.authLogin({
																		...loggedInUser,
																		personId: obj,
																	})
																);
															})
															.catch((err) => {
																console.log(err);
															});
														setHelperText((pre) => {
															pre.disableContactNumber = true;
															pre.onChangePhoneNumber = false;
															return { ...pre };
														});
														verifiedPhoneNumber.current = false;
													}}
												/>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
						<div className={cssClasses.content}>
							<div className={cssClasses.profileCardHeader}>
								<div className={cssClasses.salesMangerText}>Sales Manager Details</div>
							</div>
							{loggedInUser?.userId ? <div className={cssClasses.profileDetailsContent}>
								<div className={cssClasses.SalesManagerText}>{loggedInUser.userId?.name ? loggedInUser.userId?.name : "NA"}</div>
								<div className={cssClasses.salesMangerData}>
									<div className={cssClasses.salesContentDetails}>
										<img className={cssClasses.profileImg} src={MailIcon} alt="mail" /> {loggedInUser.userId?.email ? loggedInUser.userId?.email : "NA"}
									</div>
									<div className={cssClasses.salesContentDetails}>
                                        <img className={cssClasses.profileImg} src={PhoneCallIcon} alt="call" />
                                        {loggedInUser.userId?.assignedCallerDid ? `${loggedInUser.userId?.assignedCallerDid}` : "NA"}
                                    </div>
								</div>
							</div> : <div className={cssClasses.profileDetailsContent}> <div className={cssClasses.SalesManagerText}>NA
								</div> </div>}
						</div>
						<div className={cssClasses.content}>
							<div className={cssClasses.profileDetailsContent}>
								<div className={cssClasses.salesContentSecData}>
									<img className={cssClasses.profileImg} src={UserIcon} alt="mail" />
									<div className={cssClasses.profileCP}>
										<span>Channel Partner:</span>{" "}
										<span>{loggedInUser.cpId?.billingName ? loggedInUser.cpId?.billingName : "NA"}</span>
									</div>
								</div>
								<Divider />
								<div className={cssClasses.salesContentSecData}>
									<img className={cssClasses.profileImg} src={UserIcon} alt="mail" />
									<div className={cssClasses.profileCP}>
										<span>FoS: </span> <span>{loggedInUser.fosId?.name ? loggedInUser.fosId?.name : "NA"}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* <VirtaulAccountCard /> */}
					<div className={cssClasses.contentWrapOne}>
						{!loggedInUser?.virtualAccDetails && (
							<div className={cssClasses.content}>
								<div className={cssClasses.noDataWrapper}>
									<div className={cssClasses.noDataMsg}>
										<div className={cssClasses.emptyIcon}>
											<img src={EmptyListIcon} alt="Virtual account not created" />
										</div>
										<div className={cssClasses.emptyTitle}>Virtual account not created!</div>
									</div>
								</div>
							</div>
						)}
						{loggedInUser?.virtualAccDetails && (
							<div className={cssClasses.content}>
								<div className={cssClasses.profileCardHeader}>
									<div className={cssClasses.userDisplayID}>
										Virtual Account Details
										{virtualAccStatuses === "closed" ? (
											<>
												<LeadStatusChip
													label={"Closed"}
													icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
													style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
												></LeadStatusChip>
												<div>
													<img
														data-tooltip-id={"closed"}
														src={InfoIcon}
														aria-label={"closed"}
														alt="info"
														style={{
															verticalAlign: "middle",
															marginLeft: 4,
															cursor: "pointer",
														}}
													/>
													<ReactTooltip
														style={{
															fontFamily: "Inter-Regular",
															fontSize: "1.4rem",
															overflow: "auto",
															width: !showVirtualAccountCard ? " " : "80vw",
															cursor: "pointer",
														}}
														content={
															"Any funds transferred to this account will be refunded, as the account is currently closed."
														}
														id={"closed"}
													/>
												</div>
											</>
										) : virtualAccStatuses ? (
											<LeadStatusChip
												label={virtualAccStatuses}
												icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
												style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
											></LeadStatusChip>
										) : (
											""
										)}
									</div>
								</div>
								<div className={cssClasses.profileDetailsContent}>
									<div className={cssClasses.textFields}>
										<div className={cssClasses.infoRow}>
											<div className={cssClasses.mobileLabel}>Account Number :</div>
											<div className={cssClasses.labelData}>{loggedInUser?.virtualAccDetails?.bankAccountNumber}</div>
											<div className={cssClasses.mobileLabel}>IFSC Code :</div>
											<div className={cssClasses.labelData}>{loggedInUser?.virtualAccDetails?.bankIFSCCode}</div>
											{/* <div className={cssClasses.mobileLabel}>UPI ID :</div>
							<div className={cssClasses.labelData}>{loggedInUser?.virtualAccDetails?.bankUpiId}</div> */}
											<div className={cssClasses.mobileLabel}>Bank Beneficiary Name :</div>
											<div className={cssClasses.labelData}>{loggedInUser?.virtualAccDetails?.bankBeneficiaryName}</div>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>

				<div className={cssClasses.wrapperSwitchUser}>
					<div className={cssClasses.contentBody}>
						<Grid
							container
							spacing={{ xs: 2, md: 3 }}
							columns={{ xs: 4, sm: 8, md: 12 }}
							sx={{ flexDirection: { xs: "row", md: "row" } }}
						>
							{allUsers.map((lead, index) => (
								<Grid item key={index} xs={12} sm={12} md={6} sx={{ width: "calc(100% - 4.8rem)" }}>
									<Card className={cssClasses.cardData}>
										<div className={cssClasses.cardHeader}>
											<div className={cssClasses.userId}>{`VJ${
												lead.Leads[0].leadDisplayId.slice(0, -4) + "-" + lead.Leads[0].leadDisplayId.slice(-4)
											}`}</div>
											<div className={cssClasses.userSatus}>
												<LeadStatusChip
													label={lead.Leads[0].LeadStatus[0].status}
													style={{
														color: lead.leadStatusObj.chipColor,
														backgroundColor: lead.leadStatusObj.chipBackgroundColor,
														// fontFamily: "Inter-Regular",
														fontSize: "1.6rem",
													}}
													icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
												/>
											</div>
										</div>

										<CardContent>
											<div className={cssClasses.cardMainContent}>
												<div className={cssClasses.cardContentBlock}>
													<div className={cssClasses.leadImgName}>
														<img src={ProfileUserIcon} alt="user" />
														<div className={cssClasses.cardContentText}>{lead.Leads[0]?.personId?.name}</div>
													</div>
													<div className={cssClasses.cardLeadLastUpdate}>
														{new Date(lead.Leads[0].LeadStatus[0].last_updated_at).toDateString()},{" "}
														{new Date(lead.Leads[0].LeadStatus[0].last_updated_at).toLocaleTimeString([], {
															hour: "2-digit",
															minute: "2-digit",
														})}
													</div>
												</div>
												<div className={cssClasses.cardContentBlock}>
													<div className={cssClasses.cardCPText}>CP: {lead?.Leads[0]?.cpId?.billingName ?? "NA"}</div>
													{selectedUser !== lead.personId && (
														<div>
															<Button
																style={{
																	color: "#ffffff",
																	backgroundColor: "#3B82F6",
																	padding: "1rem",
																	borderRadius: 10,
																	fontSize: "1.6rem",
																	lineHeight: "1.5rem",
																}}
																btnName={"Switch User"}
																clicked={() => {
																	setSelectedLeadData(lead);
																	let selectedUserfromArray = allUsers.filter(
																		({ personId }) => personId === lead?.personId
																	);
																	switchLoginUser(selectedUserfromArray[0].Leads[0]);
																}}
															/>
														</div>
													)}
												</div>
											</div>
										</CardContent>
									</Card>
								</Grid>
							))}
						</Grid>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Profile;

export const VirtaulAccountCard = () => {
	const [virtualAccStatuses, setVirtualAccStatuses] = useState("");
	const showVirtualAccountCard = useMediaQuery("(max-width:820px)");
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	useEffect(() => {
		if (loggedInUser?.virtualAccId) {
			getVirtualAccStatus(loggedInUser?.virtualAccId);
		}
	}, [loggedInUser]);

	async function getVirtualAccStatus(AccId) {
		presentLoader();
		await getVirtualAccountStatus(AccId)
			.then((resp) => {
				setVirtualAccStatuses(resp?.data?.status);
				dismissLoader();
			})
			.catch((err) => {
				errorTost("Request timed out. Please try again later!");
				console.error("could-not-fetch-details", err);
				dismissLoader();
			});
	}

	return !showVirtualAccountCard ? (
		<div className={cssClasses.contentWrapOne}>
			{!loggedInUser?.virtualAccDetails && (
				<div className={cssClasses.content}>
					<div className={cssClasses.noDataWrapper}>
						<div className={cssClasses.noDataMsg}>
							<div className={cssClasses.emptyIcon}>
								<img src={EmptyListIcon} alt="Virtual account not created" />
							</div>
							<div className={cssClasses.emptyTitle}>Virtual account not created!</div>
						</div>
					</div>
				</div>
			)}
			{loggedInUser?.virtualAccDetails && (
				<div className={cssClasses.content}>
					<div className={cssClasses.profileCardHeader}>
						<div className={cssClasses.userDisplayID}>
							Virtual Account Details
							{virtualAccStatuses === "closed" ? (
								<>
									<LeadStatusChip
										label={"Closed"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
									></LeadStatusChip>
									<div>
										<img
											data-tooltip-id={"closed"}
											src={InfoIcon}
											aria-label={"closed"}
											alt="info"
											style={{
												verticalAlign: "middle",
												marginLeft: 4,
												cursor: "pointer",
											}}
										/>
										<ReactTooltip
											style={{
												fontFamily: "Inter-Regular",
												fontSize: "1.4rem",
												overflow: "auto",
												width: !showVirtualAccountCard ? " " : "80vw",
												cursor: "pointer",
											}}
											content={"Any funds transferred to this account will be refunded, as the account is currently closed."}
											id={"closed"}
										/>
									</div>
								</>
							) : virtualAccStatuses ? (
								<LeadStatusChip
									label={virtualAccStatuses}
									icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
									style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
								></LeadStatusChip>
							) : (
								""
							)}
						</div>
					</div>
					<div className={cssClasses.profileDetailsContent}>
						<div className={cssClasses.textFields}>
							<div className={cssClasses.infoRow}>
								<div className={cssClasses.mobileLabel}>Account Number :</div>
								<div className={cssClasses.labelData}>{loggedInUser?.virtualAccDetails?.bankAccountNumber}</div>
								<div className={cssClasses.mobileLabel}>IFSC Code :</div>
								<div className={cssClasses.labelData}>{loggedInUser?.virtualAccDetails?.bankIFSCCode}</div>
								{/* <div className={cssClasses.mobileLabel}>UPI ID :</div>
							<div className={cssClasses.labelData}>{loggedInUser?.virtualAccDetails?.bankUpiId}</div> */}
								<div className={cssClasses.mobileLabel}>Bank Beneficiary Name :</div>
								<div className={cssClasses.labelData}>{loggedInUser?.virtualAccDetails?.bankBeneficiaryName}</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	) : null;
};
